import { Component, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'yat-dropdown-link',
  templateUrl: './dropdown-link.component.html',
  styleUrls: ['./dropdown-link.component.scss']
})
export class DropdownLinkComponent {
  constructor(private eRef: ElementRef, private renderer: Renderer2) {}
  private static counter = 0;

  active: boolean = false;
  isOpen = false;

  @Input() position: 'left' | 'right' = 'left';

  @Input() placement: 'top' | 'bottom' = 'bottom';

  @HostListener('document:click', ['$event'])
  clickOutside(event: { target: any }): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.active = this.isOpen;
    }
  }

  toggleDropdown($event?: KeyboardEvent): void {
    if (!$event || $event.key === 'Enter') {
      this.isOpen = !this.isOpen;
      this.active = this.isOpen;
    }
  }
}
